import { render, staticRenderFns } from "./testes.vue?vue&type=template&id=18c1d992"
import script from "./testes.vue?vue&type=script&lang=ts"
export * from "./testes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports